import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type InitiativeModel from './initiative';

export default class ArtifactModel extends Model {
  declare [Type]: 'artifact';
  @attr('string') declare name: string;
  @attr('string') declare content: string;
  @belongsTo('initiative', {
    async: true,
    inverse: 'artifacts',
  })
  declare initiative: AsyncBelongsTo<InitiativeModel>;

  @attr declare created_by: string;
  @attr declare created_at: string;
}
